import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";
import { useContent } from "@/content/ContentContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const WhatsAppFab = () => {
  const { t } = useLang();
  const { waLink } = useContent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-fab"
          aria-label={t.contatti.cta}
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-bordeaux text-ivory pl-4 pr-5 py-3 shadow-lg shadow-anthracite/20"
        >
          <WhatsAppIcon className="w-4 h-4" />
          <span className="text-sm font-medium">{t.nav.book}</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppFab;
